import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import Docs from '/src/_includes/braintree-note.md';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Docs mdxType="Docs" />
    <h1 {...{
      "id": "add-vault-to-module-dependencies"
    }}>{`Add vault to module dependencies`}</h1>
    <p>{`You need to add dependencies on the Magento_Vault module in the payment method's `}<inlineCode parentName="p">{`composer.json`}</inlineCode>{` and `}<inlineCode parentName="p">{`module.xml`}</inlineCode>{` files.`}</p>
    <h2 {...{
      "id": "example-adding-vault-module-dependencies-for-the-braintree-payment-method"
    }}>{`Example: adding Vault module dependencies for the Braintree payment method`}</h2>
    <p><inlineCode parentName="p">{`app/code/Magento/Braintree/composer.json`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
    "name": "magento/module-braintree",
    ...
    "require": {
        ...
        "magento/module-vault": "100.1.*"
        ...
    }
    ...
}
`}</code></pre>
    <p><inlineCode parentName="p">{`app/code/Magento/Braintree/etc/module.xml`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-xml"
      }}>{`<config xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:noNamespaceSchemaLocation="urn:magento:framework:Module/etc/module.xsd">
    <module name="Magento_Braintree" setup_version="2.0.0">
        <sequence>
            ...
            <module name="Magento_Vault"/>
            ...
        </sequence>
    </module>
</config>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      